<div #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" ngbNav>

  @if (isApplyToMachinesOfSameTagVisible) {
    <div class="custom-control custom-switch align-self-center nav-tabs-setting">
      <input (change)="onApplyToMachinesOfSameTagChange($event)"
             [checked]="isApplyToMachinesOfSameTagChecked"
             class="custom-control-input"
             [disabled]="!isApplyToMachinesOfSameTagEnabled"
             id="isTemplate"
             type="checkbox">
      <label class="custom-control-label" for="isTemplate" translate>Apply to machine tag</label>
    </div>
  }

  <div [ngbNavItem]="1">
    <a ngbNavLink translate>Signals</a>
    <ng-template ngbNavContent>
      <scitis-app-global-page-header>
        <div header-title class="page-header-title">
          <h2 class="h4">
            <span translate>Data configuration</span>: <span translate>Signals</span>
          </h2>
        </div>
        <ng-template #filterElement>
          <button (click)="onAddSignal()" [disabled]="!isHigherThanAdmin"
                  class="btn btn-primary">
            <span class="fa-solid fa-plus"></span>
            <span translate>New signal</span>
          </button>
        </ng-template>
      </scitis-app-global-page-header>

      <div class="table-responsive">
        <table class="table vertical-align-middle table-striped mb-0">
          <thead>
          <tr>
            <th><span translate>Name</span> & <span translate>Color</span></th>
            <th translate>Table</th>
            <th translate>Signal</th>
            <th><span translate>Scale</span> / <span translate>Decimals</span> / <span translate>Unit</span></th>
            <th translate>Type</th>
            @if (!isCommandModeDisabled) {
              <th><span translate>Writable</span></th>
            }
            <th class="text-right" translate>Functions</th>
          </tr>
          </thead>
          <tbody>
            @for (signal of unCalculatedSignals; track signal) {
              <tr>
                <td>
                  <div class="form-row align-items-center flex-nowrap">
                    <div class="col-auto" [title]="signal.signalColor">
                      <span class="color-circle ml-2" [style.background-color]="signal.signalColor"></span>
                    </div>
                    <div class="col">
                      <strong class="truncate truncate-sm" [innerText]="signal.name"></strong>
                      <small class="text-muted truncate truncate-sm" [innerText]="signal.label | translate"></small>
                    </div>
                  </div>
                </td>
                <td [innerText]="signal.table"></td>
                <td [innerText]="signal.signal"></td>
                <td>
                  <span [innerText]="getSignalScale(signal)"></span>
                  <span class="text-black-50">/</span>
                  <span [innerText]="getSignalDecimals(signal)"></span>
                  <span class="text-black-50">/</span>
                  <span [innerText]="signal.unit"></span>
                  @if (!signal.unit) {
                    <span>-</span>
                  }
                </td>
                <td>
                  @if (signal.isErrorWord) {
                    <span class="badge badge-pill badge-danger" translate>Status event</span>
                  }
                  @if (signal.isByteArray) {
                    <span class="badge badge-pill badge-info" translate>Byte array</span>
                  }
                  @if (!signal.isByteArray && !signal.isErrorWord) {
                    <span class="badge badge-pill badge-dark" translate>Default</span>
                  }
                </td>
                @if (!isCommandModeDisabled) {
                  <td>
                    @if (signal.writable === true) {
                      <span class="fa-solid fa-check"></span>
                    }
                  </td>
                }

                <td class="text-right">
                  <button (click)="onRemoveSignal(signal)" [disabled]="deleteButtonDisabled(signal)"
                          class="btn btn-sm btn-outline-danger"
                          [title]="deleteButtonText | translate"
                          type="button"><span
                      class="fa-solid fa-trash"></span></button>
                  <button (click)="onEdit(signal)" [disabled]="isLowerThanAdmin"
                          class="btn btn-sm btn-outline-primary ml-1"
                          [title]="'Edit signal' | translate" type="button"><span
                      class="fa-solid fa-pen"></span></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </ng-template>
  </div>
  <div [ngbNavItem]="2">
    <a ngbNavLink translate>Calculated signals</a>
    <ng-template ngbNavContent>
      <scitis-app-global-page-header>
        <div header-title class="page-header-title">
          <h2 class="h4">
            <span translate>Data configuration</span>: <span translate>Calculated signals</span>
          </h2>
        </div>
        <ng-template #filterElement>
          <button (click)="onAddCalculatedSignal()" [disabled]="!isHigherThanAdmin"
                  class="btn btn-primary">
            <span class="fa-solid fa-plus"></span><span translate>New calculated signal</span>
          </button>
        </ng-template>
      </scitis-app-global-page-header>


      <div class="table-responsive">
        <table class="table vertical-align-middle table-striped mb-0">
          <thead>
          <tr>
            <th><span translate>Name</span> & <span translate>Color</span></th>
            <th translate>Formula</th>
            <th><span translate>Decimals</span> / <span translate>Unit</span></th>
            <th translate>Stream to BigQuery</th>
            <th class="text-right" translate>Functions</th>
          </tr>
          </thead>
          <tbody>
            @for (signal of calculatedSignals; track signal) {
              <tr>
                <td>
                  <div class="form-row align-items-center flex-nowrap">
                    <div class="col-auto" [title]="signal.signalColor">
                      <span class="color-circle" [style.background-color]="signal.signalColor"></span>
                    </div>
                    <div class="col">
                      <strong [innerText]="signal.name"></strong><br/>
                      <small class="text-muted" [innerText]="signal.label | translate"></small>
                    </div>
                  </div>
                </td>
                <td [innerText]="signal.formula"></td>
                <td [innerText]="signal.decimals +'/'+ signal.unit"></td>
                <td>
                  @if (signal.streamToBigQuery) {
                    <em class="fa-solid fa-check text-success"></em>
                  } @else {
                    <em class="fa-solid fa-xmark"></em>
                  }

                </td>
                <td class="text-right">
                  <button (click)="onRemoveSignal(signal)"
                          [disabled]="!isHigherThanAdmin"
                          class="btn btn-sm btn-outline-danger"
                          [title]="'Delete signal' | translate"
                          type="button">
                    <span class="fa-solid fa-trash"></span>
                  </button>
                  <button (click)="onEditCalculatedSignal(signal)"
                          [disabled]="isLowerThanAdmin"
                          class="btn btn-sm btn-outline-primary ml-1"
                          [title]="'Edit signal' | translate" type="button">
                    <span class="fa-solid fa-pen"></span>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </ng-template>
  </div>
</div>


<div class="card card-tab-container">
  <div [ngbNavOutlet]="nav" class="card-body"></div>
</div>
